$(document).ready(function () {
    var desktopBreakpoint = 1023;
    var openDelay = 120;
    var closeDelay = 220;
    var openTimer;
    var closeTimer;

    var desktopMenus = [
        {
            trigger: "#OurProducts",
            panel: "#OurProductsContent"
        },
        {
            trigger: "#StartYourDesign",
            panel: "#StartYourDesignContent"
        },
        {
            trigger: "#InstallationMenu",
            panel: "#InstallationContent"
        },
        {
            trigger: "#NeedHelpMenu",
            panel: "#NeedHelpContent"
        }
    ];

    function isDesktop() {
        return $(window).width() > desktopBreakpoint;
    }

    function getMenu(menuSelector) {
        for (var i = 0; i < desktopMenus.length; i++) {
            if (
                desktopMenus[i].trigger === menuSelector ||
                desktopMenus[i].panel === menuSelector
            ) {
                return desktopMenus[i];
            }
        }

        return null;
    }

    function setTriggerState(triggerSelector, isOpen) {
        var $trigger = $(triggerSelector);

        $trigger.attr("aria-expanded", isOpen ? "true" : "false");
        $trigger.toggleClass("is-active", isOpen);

        $trigger.find(".on-idle").toggle(!isOpen);
        $trigger.find(".on-hover").toggle(isOpen);
    }

    function closeDesktopMenus(exceptPanel) {
        desktopMenus.forEach(function (menu) {
            if (menu.panel !== exceptPanel) {
                $(menu.panel).stop(true, true).hide();
                setTriggerState(menu.trigger, false);
            }
        });
    }

    function openDesktopMenu(menu) {
        if (!menu || !isDesktop()) {
            return;
        }

        clearTimeout(openTimer);
        clearTimeout(closeTimer);

        closeDesktopMenus(menu.panel);

        $(menu.panel).stop(true, true).fadeIn(120);
        setTriggerState(menu.trigger, true);
    }

    function closeDesktopMenu(menu) {
        if (!menu) {
            return;
        }

        $(menu.panel).stop(true, true).fadeOut(100);
        setTriggerState(menu.trigger, false);
    }

    function scheduleDesktopOpen(menu) {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);

        openTimer = setTimeout(function () {
            openDesktopMenu(menu);
        }, openDelay);
    }

    function scheduleDesktopClose(menu) {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);

        closeTimer = setTimeout(function () {
            closeDesktopMenu(menu);
        }, closeDelay);
    }

    desktopMenus.forEach(function (menu) {
        var $trigger = $(menu.trigger);
        var $panel = $(menu.panel);

        $trigger.on("mouseenter.cabjaksMenu", function () {
            scheduleDesktopOpen(menu);
        });

        $trigger.on("mouseleave.cabjaksMenu", function () {
            scheduleDesktopClose(menu);
        });

        $panel.on("mouseenter.cabjaksMenu", function () {
            clearTimeout(closeTimer);
        });

        $panel.on("mouseleave.cabjaksMenu", function () {
            scheduleDesktopClose(menu);
        });

        $trigger.on("click.cabjaksMenu", function (event) {
            event.preventDefault();

            if (!isDesktop()) {
                return;
            }

            var isCurrentlyOpen =
                $trigger.attr("aria-expanded") === "true";

            if (isCurrentlyOpen) {
                closeDesktopMenu(menu);
            } else {
                openDesktopMenu(menu);
            }
        });

        $trigger.on("keydown.cabjaksMenu", function (event) {
            if (
                event.key === "Enter" ||
                event.key === " " ||
                event.key === "ArrowDown"
            ) {
                event.preventDefault();
                openDesktopMenu(menu);

                setTimeout(function () {
                    $panel.find("a, button").first().focus();
                }, 130);
            }
        });
    });

    $(document).on("click.cabjaksDesktopMenu", function (event) {
        if (
            !$(event.target).closest(
                ".mega-nav-trigger, .mega-nav-panel"
            ).length
        ) {
            closeDesktopMenus();
        }
    });


    // Mobile navigation

    var $mobileTrigger = $("#BurgerMenuMobile");
    var $mobilePanel = $("#BurgerMenuContent");
    var $mobileOverlay = $(".mobile-overlay");

    function openMobileMenu() {
        closeDesktopMenus();

        $mobilePanel.stop(true, true).slideDown(180);
        $mobileTrigger
            .attr("aria-expanded", "true")
            .attr("aria-label", "Close navigation");

        $mobileTrigger
            .find(".burger-menu")
            .addClass("burger-menu-hover");

        $mobileOverlay.addClass("active");
    }

    function closeMobileMenu() {
        $mobilePanel.stop(true, true).slideUp(160);
        $mobileTrigger
            .attr("aria-expanded", "false")
            .attr("aria-label", "Open navigation");

        $mobileTrigger
            .find(".burger-menu")
            .removeClass("burger-menu-hover");

        $mobileOverlay.removeClass("active");
    }

    $mobileTrigger.on("click.cabjaksMenu", function (event) {
        event.stopPropagation();

        var isOpen =
            $mobileTrigger.attr("aria-expanded") === "true";

        if (isOpen) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    $mobilePanel.on("click.cabjaksMenu", function (event) {
        event.stopPropagation();
    });

    $(document).on("click.cabjaksMobileMenu", function () {
        if (
            !isDesktop() &&
            $mobileTrigger.attr("aria-expanded") === "true"
        ) {
            closeMobileMenu();
        }
    });


    // Mobile accordionsshopify-vfs://cabjaks-dev-store.myshopify.com/themes/163614720131/theme-export-cabjaks-co-nz-cabjaks-shopify-mas/assets/cabjaks-search.js

    $(".accordion__title").on("click.cabjaksAccordion", function () {
        var $title = $(this);
        var $accordion = $title.closest(".accordion");
        var $content = $accordion.children(".accordion__content").first();
        var isOpen = $accordion.hasClass("accordion--open");

        if (isOpen) {
            $content.stop(true, true).slideUp(160);
            $accordion.removeClass("accordion--open");
            $title.attr("aria-expanded", "false");
        } else {
            $content.stop(true, true).slideDown(180);
            $accordion.addClass("accordion--open");
            $title.attr("aria-expanded", "true");
        }
    });


    // Keyboard and viewport handling

    $(document).on("keydown.cabjaksMenu", function (event) {
        if (event.key === "Escape") {
            closeDesktopMenus();
            closeMobileMenu();
        }
    });

    $(window).on("resize.cabjaksMenu", function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);

        if (isDesktop()) {
            closeMobileMenu();
        } else {
            closeDesktopMenus();
        }
    });
});